import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import { getCbbos, getFpoView, patchFpo, postFpo } from '../../services/fpo';
import CustomLoading from '../../components/customLoading/CustomLoading';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import { getDistricts, getStates } from '../../services/csc_api_call';

function FpoFpoForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const [cbboDropdownData, setCbboDropdownData] = useState([]);
    const [statesDropdownData, setStatesDropdownData] = useState([]);
    const [districtsDropdownData, setDistrictsDropdownData] = useState([]);
    const [rowData, setRowData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({
        "name": "",
        "registration_no": "",
        "registration_act": "",
        "date_of_incorporation": "",
        "address": "",
        "block": "",
        "cbbo": "",
        "district": "",
        "state": ""
    });

    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = {
            name: values.name,
            registration_no: values.registration_no,
            registration_act: values.registration_act,
            date_of_incorporation: values.date_of_incorporation,
            address: values.address,
            block: values.block,
            cbbo: values.cbbo,
            district: values.district,
            state: values.state
        }
        try {
            const response = rowData ? await patchFpo({ data: formData, id: rowData.id }) : await postFpo({ data: formData });

            if (response?.status === 200 || response.status === 201) {
                toast.success(rowData ? "FPO updated successfully" : "FPO added successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };


    const fetchDetails = async (id) => {
        setLoading(true);
        try {
            let res = await getFpoView({ id: id });
            if (res.status === 200) {
                const data = res.data;
                setInitialValues(data)
                fetchDistricts({ stateId: data.state });
            } else {
                console.log("---------------------------------");
                console.log(res);
                console.log("---------------------------------");
                toast.error(res);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCbbos = async () => {
        try {
            let res = await getCbbos("");
            if (res.status === 200) {
                const data = res.data;
                setCbboDropdownData(data)
            } else {
                toast.error("Unable to fetch CBBO Dropdown");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const fetchStates = async () => {
        try {
            let res = await getStates();
            if (res.status === 200) {
                const data = res.data;
                setStatesDropdownData(data)
            } else {
                toast.error("Unable to fetch States Dropdown");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const fetchDistricts = async ({ stateId }) => {
        try {
            let res = await getDistricts({ stateId: stateId });
            if (res.status === 200) {
                const data = res.data;
                setDistrictsDropdownData(data)
            } else {
                toast.error("Unable to fetch CBBO Dropdown");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        fetchCbbos();
        fetchStates();
        if (location.state) {
            setRowData(location.state);
            fetchDetails(location.state.id);
        }
    }, [location]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: "FPOs", link: (-1) },
            { name: rowData ? "Edit FPO" : "Add FPO" },
        ]} />
        <div className="mt-8">
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading size={100} />
                    </div> :
                    <Formik
                        initialValues={initialValues}
                        validationSchema={Yup.object({
                            name: Yup.string().required("Title is required"),
                        })}
                        enableReinitialize
                        onSubmit={handleFormSubmit}
                    >
                        {({ isSubmitting, resetForm }) => (
                            <Form>
                                <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                                    <div className="flex flex-col w-full">
                                        <div className="grid gap-2 grid-cols-1 md:grid-cols-3 mb-3">
                                            <InputField
                                                label="Name"
                                                name="name"
                                                type="text"
                                                placeholder="FPO name"
                                                required
                                            />
                                            <InputField
                                                label="Registration No"
                                                name="registration_no"
                                                type="text"
                                                placeholder="XXXXXXX.......XXXX"
                                            />
                                            <InputField
                                                label="Registration Act"
                                                name="registration_act"
                                                type="text"
                                                placeholder="Company Act."
                                            />
                                        </div>
                                        <div className="grid gap-2 grid-cols-1 md:grid-cols-3 mb-3">
                                            <InputField
                                                label="Date of Incorporation"
                                                name="date_of_incorporation"
                                                type="date"
                                                placeholder="DD-MM-YYYY"
                                            />
                                            <InputField
                                                label="Block"
                                                name="block"
                                                type="text"
                                                placeholder="Block Name"
                                            />
                                            <FormikDropdown
                                                label="CBBO"
                                                name="cbbo"
                                                placeholder="CBBO"
                                                options={cbboDropdownData.map((e) => ({ label: e.name, value: e.id }))}
                                                needSearch
                                            />
                                        </div>
                                        <div className="grid gap-2 grid-cols-1 md:grid-cols-3 mb-3">
                                            <InputField
                                                label="Address"
                                                name="address"
                                                type="text"
                                                placeholder="Address"
                                            />
                                            <FormikDropdown
                                                label="State"
                                                name="state"
                                                placeholder="State"
                                                options={statesDropdownData.map((e) => ({ label: e.name, value: e.id }))}
                                                needSearch
                                                onChange={(e) => fetchDistricts({ stateId: e.label })}
                                            />
                                            <FormikDropdown
                                                label="District"
                                                name="district"
                                                placeholder="District"
                                                options={districtsDropdownData.map((e) => ({ label: e.name, value: e.id }))}
                                                needSearch
                                            />

                                        </div>
                                        <div className="py-5 flex justify-end gap-6">
                                            <div>
                                                <Button
                                                    type="button"
                                                    className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                                    onClick={() => handleDiscardChanges(resetForm)}
                                                    disabled={isSubmitting}
                                                >
                                                    Discard Changes
                                                </Button>
                                            </div>
                                            <div>
                                                <Button
                                                    type="submit"
                                                    className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? "Saving..." : "Save"}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
            }
        </div>
    </>);
}

export default FpoFpoForm;